import { Colors } from 'ComponentLibrary/src/styles'
import React from 'react'

export const pxToRemValue = (size: number, rootFontSize = 16) => size / rootFontSize
export const pxToRemString = (size: number, rootFontSize = 16) => `${pxToRemValue(size, rootFontSize)}rem`

const fontFamily = 'Inter'
const fontWeightRegular = 400
const fontWeightMedium = 500

const fonts: Record<
    | 'headline1'
    | 'headline2'
    | 'headline3'
    | 'headline4'
    | 'headline5'
    | 'subtitle1'
    | 'bodyTextLarge'
    | 'bodyTextMedium'
    | 'bodyTextSmall'
    | 'bodyTextXSmall'
    | 'captionSmall'
    | 'captionMedium'
    | 'monetaryValueXLarge'
    | 'monetaryValueLarge'
    | 'monetaryValueMedium'
    | 'bodyTextLargeBlack',
    {
        fontSize: string
        fontWeight: number
    } & React.CSSProperties & {
            '&:hover'?: React.CSSProperties
        }
> = {
    headline1: {
        fontSize: pxToRemString(24),
        fontWeight: 500,
    },
    headline2: {
        fontSize: pxToRemString(18),
        fontWeight: 500,
    },
    headline3: {
        fontSize: pxToRemString(16),
        fontWeight: 500,
    },
    headline4: {
        fontSize: pxToRemString(16),
        fontWeight: 400,
    },
    headline5: {
        fontSize: pxToRemString(12),
        fontWeight: 500,
    },
    bodyTextLarge: {
        fontSize: pxToRemString(16),
        fontWeight: 400,
    },
    bodyTextLargeBlack: {
        fontSize: pxToRemString(16),
        fontWeight: 400,
        color: `${Colors.customtext.black100}!important`,
    },
    bodyTextMedium: {
        fontSize: pxToRemString(14),
        fontWeight: 400,
    },
    bodyTextSmall: {
        fontSize: pxToRemString(12),
        fontWeight: 400,
    },
    bodyTextXSmall: {
        fontSize: pxToRemString(10),
        fontWeight: 400,
    },
    captionSmall: {
        fontSize: pxToRemString(11),
        fontWeight: 500,
        textTransform: 'uppercase',
        color: `${Colors.customtext.darkblue50}`,
    },
    captionMedium: {
        fontSize: pxToRemString(14),
        textTransform: 'uppercase',
        fontWeight: 500,
    },
    subtitle1: {
        fontSize: pxToRemString(11),
        fontWeight: 400,
    },
    monetaryValueXLarge: {
        fontSize: '1.625rem',
        fontWeight: 700,
    },
    monetaryValueLarge: {
        fontSize: '1.375rem',
        fontWeight: 700,
    },
    monetaryValueMedium: {
        fontSize: '0.875rem',
        fontWeight: 700,
    },
}

export default { fonts, fontFamily, fontWeightRegular, fontWeightMedium }
